import { useEffect, useState } from 'react';
import jalaali from 'jalaali-js';
import DateObject from 'react-date-object';
import persian from 'react-date-object/calendars/persian';
import persian_fa from 'react-date-object/locales/persian_fa';
import client from '../api/client';

// Converts a Gregorian "YYYY-MM-DD" from the API into the Persian DateObject the
// calendar expects. The API stays Gregorian end to end; Jalali exists only in
// the display layer.
const toPersian = (isoDate) => {
  const [gy, gm, gd] = isoDate.split('-').map(Number);
  const { jy, jm, jd } = jalaali.toJalaali(gy, gm, gd);
  return new DateObject({ year: jy, month: jm, day: jd, calendar: persian, locale: persian_fa });
};

// Fetched once per mount and shared by both calendars. The backend serves this
// from a cached snapshot, so it is a cheap call -- but it should still not be
// re-issued every time a calendar popover opens.
export const useDateBounds = () => {
  const [bounds, setBounds] = useState({
    minDate: null,
    maxDate: null,
    dateLimit: null,
    policyName: null,
    loading: true,
    error: null,
  });

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        const { data } = await client.get('panel/date-bounds');
        if (cancelled) return;
        setBounds({
          minDate: toPersian(data.min_date),
          maxDate: toPersian(data.max_date),
          dateLimit: data.date_limit,
          policyName: data.policy_name,
          loading: false,
          error: null,
        });
      } catch (error) {
        if (cancelled) return;
        // Leave the dates null so the calendar stays disabled rather than
        // silently falling back to a window the backend would reject.
        setBounds((prev) => ({ ...prev, loading: false, error }));
      }
    })();

    return () => { cancelled = true; };
  }, []);

  return bounds;
};

export default useDateBounds;
